import { Icons } from 'src/common/components'
import { IOption } from 'src/common/interfaces'

import { BasicMultiSelectGroupsOptions } from '../components'
import styles from './basic-multi-select-groups-search.module.scss'

interface BasicMultiSelectGroupsSearchProps {
  currentValue: string[]
  searchValue: string
  options: IOption[]
  onSearchChange: (value: string) => void
  onChange: (newValue: string) => void
}

const BasicMultiSelectGroupsSearch = (
  props: BasicMultiSelectGroupsSearchProps,
) => {
  const { currentValue, searchValue, options, onSearchChange, onChange } = props

  const currentOptions = options.filter((option) =>
    option.label.toLowerCase().includes(searchValue.toLowerCase()),
  )

  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.icon}>
          <Icons.Search />
        </div>

        <input
          value={searchValue}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>

      {searchValue ? (
        <BasicMultiSelectGroupsOptions
          currentValue={currentValue}
          options={currentOptions}
          onChange={onChange}
        />
      ) : null}
    </>
  )
}

export default BasicMultiSelectGroupsSearch
